/**
 * Created by RanAn on 2021/05/01.
 */
/* jshint esversion: 8 */
import axios from 'axios';
import Router from '../router';

const dataURL = process.env.VUE_APP_DATA_URL
const loginURL = process.env.VUE_APP_LOGIN_URL

const instance = axios.create({
  withCredentials: true,
});

let isLoggingIn = false;
// http response 响应拦截器
instance.interceptors.request.use(config => {
  config.headers['token'] = sessionStorage.getItem("token");
  config.headers['user_id'] = sessionStorage.getItem("user_id");
  config.headers['app_link'] = sessionStorage.getItem("app_link");
  config.headers['login_id'] = sessionStorage.getItem("login_id");
  return config;
},error => {
  console.log('request error', error);
  return Promise.reject(error);
});

// 🚨 统一处理 401
function handle401() {
  // ✅ 如果已经在登录，直接挂起请求
  if (isLoggingIn) {
    return new Promise(() => {}); // 阻止继续执行（关键）
  }

  // ✅ 只允许触发一次登录
  isLoggingIn = true;

  console.log("🚨 Trigger login only once");

  // 清理 sessionStorage (per-tab isolation)
  sessionStorage.clear();
  // 👉 稍微延迟一下（可选，避免瞬间抖动）
  setTimeout(() => {
    window.location = loginURL;
  }, 300);

  // 挂起当前请求
  return new Promise(() => {});
}

instance.interceptors.response.use(response => {
  switch (response.data.code) {
    case 403:
      Router.push('/forbidden');
      return Promise.reject(response);
    case 401:
      return handle401();
    
    default:
      return response;
  }

}, error => {
  if (error.response) {
    // switch (error.response.code) {
    switch (error.response.status) {
      case 403:
        Router.push('/forbidden');
        break;
      case 401:
        return handle401();
      default:

    }
    return Promise.reject(error.response.data);
  }
});

export default {
  getSeviceUrl() {
    return instance.get(`${dataURL}/api/sevice/url`);
  },
  getHtmlConst() {
    return instance.get(`${dataURL}/api/html/const`,);
  },
  getHtmlConstRecording() {
    return instance.get(`${dataURL}/api/html/const/recording`,);
  },
  getUserInfo() {
    return instance.get(`${dataURL}/api/user/info`,);
  },
  getUserEcharts(user_id) {
    return instance.get(`${dataURL}/api/user/echarts?user_id=${user_id}`);
  },
  getUserModeEcharts(user_id, mode) {
    return instance.get(`${dataURL}/api/user/mode/echarts?user_id=${user_id}&mode=${mode}`);
  },
  getPresenceStatus() {
    return instance.get(`${dataURL}/api/presence/status`);
  },
  getPresenceMode() {
    return instance.get(`${dataURL}/api/presence/mode`);
  },
  getF2FStatus() {
    return instance.get(`${dataURL}/api/f2f/status`);
  },
  getTelStatus() {
    return instance.get(`${dataURL}/api/tel/status`);
  },
  getChatPersonStatus() {
    return instance.get(`${dataURL}/api/chat/preson/status`);
  },
  getChatStatus() {
    return instance.get(`${dataURL}/api/chat/status`);
  },
  getChatAnswerStatus() {
    return instance.get(`${dataURL}/api/chat/answer/status`);
  },
  getPresenceTableDetail(user_id) {
    return instance.get(`${dataURL}/api/table/detail/presence?userId=${user_id}`);
  },
  getChatRealTimeTableDetail(user_id) {
    return instance.get(`${dataURL}/api/realtime/table/detail/chat?userId=${user_id}`);
  },
  getChatDailyTableDetail(user_id) {
    return instance.get(`${dataURL}/api/daily/table/detail/chat?userId=${user_id}`);
  },
  getTelRealTimeTableDetail(user_id) {
    return instance.get(`${dataURL}/api/realtime/table/detail/tel?userId=${user_id}`);
  },
  getTelDailyTableDetail(user_id) {
    return instance.get(`${dataURL}/api/daily/table/detail/tel?userId=${user_id}`);
  },
  getF2FRealTimeTableDetail(user_id) {
    return instance.get(`${dataURL}/api/realtime/table/detail/f2f?userId=${user_id}`);
  },
  getF2FDailyTableDetail(user_id) {
    return instance.get(`${dataURL}/api/daily/table/detail/f2f?userId=${user_id}`);
  },
  getUC3config() {
    return instance.get(`${dataURL}/api/uc3/config`);
  },
  getReleaseStatusChart() {
    return instance.get(`${dataURL}/api/release/status`);
  },
  getDailyNgWordsCount(type) {
    return instance.get(`${dataURL}/api/daily/ngword/count?type=${type}`);
  },
  getDailyLongTimesCount() {
    return instance.get(`${dataURL}/api/daily/longtime/count`);
  },
  //todo: sv daily here
  getDailySVCount() {
    return instance.get(`${dataURL}/api/daily/sv/count`);
  },
  getCategoryList() {
    return instance.get(`${dataURL}/api/category`);
  },
  getPeriodList() {
    return instance.get(`${dataURL}/api/period`);
  },
  getMemberList() {
    return instance.get(`${dataURL}/api/member`);
  },
  getFacetList() {
    return instance.get(`${dataURL}/api/facet`);
  },
  getAssistantTicketCountByMonth(stt_mode, baseMonth, facetList, age, sex) {
    return instance.get(`${dataURL}/api/month/assistant/ticket/count?stt_mode=${stt_mode}&baseMonth=${baseMonth}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getCancelDailPercent(baseMonth) {
    return instance.get(`${dataURL}/api/cancel/daily/percent?baseMonth=${baseMonth}`);
  },
  getChatbotAnswerCount(startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbot/answer/count?startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotOperateCount(period, baseMonth, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbot/operate/count?period=${period}&baseMonth=${baseMonth}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotPeriodCount(startDate, endDate, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbot/period/count?startDate=${startDate}&endDate=${endDate}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotTicketCountByMonth(baseMonth,facetList, age, sex) {
    return instance.get(`${dataURL}/api/month/chatbot/ticket/count?baseMonth=${baseMonth}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotQuestionCount(startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbot/question/count?startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotSurveyEvaluateBySMS(startDate, endDate, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbot/survey/evaluate/sms?startDate=${startDate}&endDate=${endDate}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotSurveyEvaluate(startDate, endDate, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbot/survey/evaluate?startDate=${startDate}&endDate=${endDate}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getTelephoneAnswerCount(stt_mode, period, baseMonth, facetList, age, sex) {
    return instance.get(`${dataURL}/api/telephone/answer/count?stt_mode=${stt_mode}&period=${period}&baseMonth=${baseMonth}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getTelphoneAnswersChooseCount(stt_mode, startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/telphone/answers/choose/count?stt_mode=${stt_mode}&startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotSupportAnswersCount(startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbotsupport/answers/count?startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotSupportCustomerSurveyEvaluateCount(startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbotsupport/customer/survey/evaluate/count?startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotSupportSurveyEvaluateCount(startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbotsupport/survey/evaluate/count?startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotSupportCompatibilityLevel(startDate, endDate, selectvalue) {
    return instance.get(`${dataURL}/api/chatbotsupport/compatibility/level?startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}`);
  },
  getTelphoneNGWordsCount(stt_mode, startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/telphone/ngWord/count?stt_mode=${stt_mode}&startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getTelphoneAverageTimeCount(startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/telphone/average/time/count?startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getChatbotSupportAverageTimeCount(startDate, endDate, selectvalue, facetList, age, sex) {
    return instance.get(`${dataURL}/api/chatbotsupport/average/time/count?startDate=${startDate}&endDate=${endDate}&selectvalue=${selectvalue}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getTelphoneStatusTimesCount(stt_mode, period, baseMonth) {
    return instance.get(`${dataURL}/api/telphone/status/time/count?stt_mode=${stt_mode}&period=${period}&baseMonth=${baseMonth}`);
  },
  getBuzzWordCount(startDate, endDate, facetList, age, sex) {
    return instance.get(`${dataURL}/api/buzzword/count?startDate=${startDate}&endDate=${endDate}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  getTelephoneTalkWorkCountChart(period, baseMonth) {
    return instance.get(`${dataURL}/api/telephone/talk/work/count?period=${period}&baseMonth=${baseMonth}`);
  },
  getChatbotSupportTicketTimeCount(startDate, endDate) {
    return instance.get(`${dataURL}/api/chatbotsupport/ticket/time/count?startDate=${startDate}&endDate=${endDate}`);
  },
  getPicMapCount(date, group, mode, checkedServiceTime) {
    return instance.get(`${dataURL}/api/picmap/count?date=${date}&group=${group}&mode=${mode}&checkedServiceTime=${checkedServiceTime}`);
  },
  getUserChatText(userId, issueId) {
    return instance.get(`${dataURL}/api/user/chat/text?userId=${userId}&issueId=${issueId}`);
  },
  getUserAllText(userAddress) {
    return instance.get(`${dataURL}/api/user/all/text?userAddress=${userAddress}`);
  },
  // ==========================================
  // 修正日時: 2026-01-22
  // 修正内容: ボイスボットのテキストモニタリング対応
  //           - 電話番号ベースのテキスト取得API追加
  // ==========================================
  getUserAllTextByPhone(phoneNumber) {
    return instance.get(`${dataURL}/api/user/all/text/by/phone?phoneNumber=${phoneNumber}`);
  },
  getUserAllTextByChannel(channelId){
    return instance.get(`${dataURL}/api/user/all/text/by/channel?channelId=${channelId}`);
  },
  logout() {
    return instance.get(`${loginURL}/logout`);
  },
  saveTextStatus(params) {
    return instance.post(`${dataURL}/api/text/status`, params);
  },
  saveUserEchartStatus(params) {
    return instance.post(`${dataURL}/api/user/echarts/flg`, params);
  },
  saveUserEcharIndex(params) {
    return instance.post(`${dataURL}/api/user/echarts/index`, params);
  },
  createThreeCall(conUuid, num) {
    return instance.get(`${dataURL}/api/three/call?conUuid=${conUuid}&num=${num}`);
  },
  closeDialog(params) {
    return instance.post(`${dataURL}/api/close/dialog`, params);
  },
  sendMessage(userId, customId, message, type){
    return instance.get(`${dataURL}/api/chat/message/info?userId=${userId}&customId=${customId}&message=${message}&type=${type}`);
  },
  chatClose(userId, customId){
    return instance.get(`${dataURL}/api/chat/end?userId=${userId}&customId=${customId}`);
  },
  changeDashboardType(userId, type) {
    return instance.get(`${dataURL}/api/dashboard/type/change?userId=${userId}&type=${type}`);
  },
  svhelpOnSupport(mode, operatorId, svId, customerId) {
    return instance.get(`${dataURL}/api/sv/help/support?modeName=${mode}&operatorId=${operatorId}&customerId=${customerId}&svId=${svId}`);
  },
  resetSvhelpOnSupport(mode, operatorId, svId, customerId) {
    return instance.get(`${dataURL}/api/sv/help/support/reset?modeName=${mode}&operatorId=${operatorId}&customerId=${customerId}&svId=${svId}`);
  },
  getRecording(params){
    return instance.post(`${dataURL}/api/recording/wav/list`, params);
  },
  getNgWord(ticketNo){
    return instance.get(`${dataURL}/api/recording/ngWord?issueId=${ticketNo}`);
  },
  // ==========================================
  // 修正日時: 2026-02-09
  // 修正内容: 録音再生ダイアログ用 - Redmine custom_values(233/12)から全文テキスト取得API
  getDialogContent(issueId) {
    return instance.get(`${dataURL}/api/recording/dialogContent?issueId=${issueId}`);
  },
  getSipConfig() {
    return instance.get(`${dataURL}/api/sip/config`);
  },
  deleteWavFile(id, wavPath) {
    return instance.post(`${dataURL}/api/usr-call-record/delete-wav-file`, {id, wavPath});
  },
  getDownload(url){
    return instance({method: "get", url:`${dataURL}/api/download/wav?filePath=${url}`, responseType: "blob"});
  },
  getUserInfoByType(params,type){
    if(type == 'internal'){
      return instance.get(`${dataURL}/api/internal/user/tel?phonenum=${params.phonenum}`);
    }else{
      return instance.get(`${dataURL}/api/customer/info/num?phonenum=${params.phonenum}`);
    }
  },
  getCustomerInfoByPage(params){
    let url = `${dataURL}/api/customer/info/?page=${params.page}&pageSize=${params.pageSize}`
    if(params.keyword){
      url = `${url}&keyword=${params.keyword}`
    }
    return instance.get(url);
  },
  getPbxUserStatus(){
    return instance.get(`${dataURL}/api/op/getPbxUserStatus`)
  },
  getOnCallInfo(telNum) {
    return instance.get(`${dataURL}/api/getOnCallInfo?telNum=${telNum}`)
  },
  callAnswered(params){
    return instance.post(`${dataURL}/api/call/answered`,params);
  },
  callEnd(params){
    return instance.post(`${dataURL}/api/call/end`,params);
  },
  getEmpathyMatchingInfo(params){
    return instance.post(`${dataURL}/api/empathy/info`,params)
  },
  getVoicebotCategoryList(){
    return instance.get(`${dataURL}/api/voicebot/category`);
  },
  getSystemConfig(){
    return instance.get(`${dataURL}/api/system/config`);
  },
  
  // ========== New: AI Voicebot dedicated APIs (no stt_mode parameter) ==========
    
  // 2. First-time answer count aggregation
  getVoicebotAnswerCount(period, baseMonth, facetList, age, sex) {
    return instance.get(`${dataURL}/api/voicebot/answer/count?period=${period}&baseMonth=${baseMonth}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  /**
   * Get voicebot call duration distribution
   * Purpose: Retrieve call count statistics grouped by duration categories (1-10 minutes and >10)
   *
   * @param {string} startDate - Start date (YYYY-MM-DD)
   * @param {string} endDate - End date (YYYY-MM-DD)
   * @param {string} facetList - Comma-separated facet filter list
   * @param {string} age - Age filter (optional)
   * @param {string} sex - Gender filter (optional)
   * @returns {Promise} API response with duration distribution data
   */
  getVoicebotCallDurationDistribution(startDate, endDate, facetList, age, sex) {
    return instance.get(`${dataURL}/api/voicebot/call/duration/distribution?startDate=${startDate}&endDate=${endDate}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },
  
  // Response Type Count Chart - 応対種別応対件数集計
  getResponseTypeCount(period, baseMonth, facetList, age, sex) {
    return instance.get(`${dataURL}/api/response/type/count?period=${period}&baseMonth=${baseMonth}&facetList=${facetList}&age=${age}&sex=${sex}`);
  },

  // ==========================================
  // 修正日時: 2026-05-19
  // 修正内容: 作業完了(ACW COMPLETED)ステータスの取得・更新API
  // ==========================================
  getAcwCompleted(issueId) {
    return instance.get(`${dataURL}/api/acw/completed?issue_id=${issueId}`);
  },
  updateAcwCompleted(issueId, value) {
    return instance.post(`${dataURL}/api/acw/completed`, { issue_id: issueId, value: value });
  }
};
